import {
	Component,
	OnDestroy,
	OnInit,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import {
	MatAutocomplete,
	MatAutocompleteModule,
	MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import { SearchDropdownOptionComponent } from './search-dropdown-option/search-dropdown-option.component';
import {
	GroupedSearchItemDto,
	SearchClient,
} from 'app/core/services/api.service';
import {
	Observable,
	Subject,
	debounceTime,
	distinctUntilChanged,
	filter,
	of,
	takeUntil,
} from 'rxjs';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';

@Component({
    selector: 'cm-search-dropdown',
    imports: [
        AsyncPipe,
        ReactiveFormsModule,
        MatIconModule,
        MatAutocompleteModule,
        SearchDropdownOptionComponent,
    ],
    templateUrl: './search-dropdown.component.html',
    styleUrls: ['./search-dropdown.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SearchDropdownComponent implements OnInit, OnDestroy {
	searchControl: FormControl = new FormControl();
	searchResult$: Observable<GroupedSearchItemDto[]>;

	menuContent: boolean = false;

	@ViewChild(MatAutocompleteTrigger)
	oMatAutoComplete: MatAutocompleteTrigger;

	private _unsubscribeAll: Subject<any> = new Subject<any>();

	constructor(
		private _searchClient: SearchClient,
		private _fuseMediaWatcherService: FuseMediaWatcherService
	) {}

	ngOnInit(): void {
		this.searchControl.valueChanges
			.pipe(
				filter((query) => !query || String(query).length >= 3),
				debounceTime(300),
				distinctUntilChanged(),
				takeUntil(this._unsubscribeAll)
			)
			.subscribe({
				next: (value) => this.onSearch(value),
			});

		// Subscribe to media changes
		this._fuseMediaWatcherService.onMediaChange$
			.pipe(takeUntil(this._unsubscribeAll))
			.subscribe(({ matchingAliases }) => {
				if (matchingAliases.includes('sm'))
					this.oMatAutoComplete?.closePanel();
			});
	}

	ngOnDestroy(): void {
		this._unsubscribeAll.next(null);
		this._unsubscribeAll.complete();
	}

	onSearch(searchPhrase: string) {
		if (!searchPhrase) {
			this.searchResult$ = of([]);

			return;
		}

		this.searchResult$ = this._searchClient.search(searchPhrase);
	}

	openSearch(autoComplete: MatAutocomplete): void {
		this.menuContent = true;
	}

	closeSearch(autoComplete: MatAutocomplete): void {
		this.menuContent = false;
		this.oMatAutoComplete.closePanel();
		this.searchControl.setValue(null);
	}

	onAutocompleteClosed() {
		this.searchControl.setValue(null);
	}
}
